import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// Page titles mapping
const pageTitles = {
  '/': 'Home',
  '/agents': 'Agent Registry',
  '/workflow-simulator': 'Workflow Simulator',
  '/developers': 'Developers',
  '/platform-economics': 'Platform Economics',
  '/research': 'Research',
  '/request-demo': 'Request Demo',
  '/user/login': 'Sign In',
  '/user/signup': 'Sign Up',
  '/user/dashboard': 'Dashboard',
  '/admin/login': 'Admin Login',
  '/admin/leads': 'Admin Panel',
};

const getPageTitle = (pathname) => {
  // Check for exact match first
  if (pageTitles[pathname]) {
    return pageTitles[pathname];
  }
  
  // Check for pattern matches
  if (pathname.startsWith('/workflows/')) {
    const workflowId = pathname.split('/')[2];
    return `Workflow: ${workflowId.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}`;
  }
  if (pathname.startsWith('/agents/')) {
    const agentId = pathname.split('/')[2];
    return `Agent: ${agentId.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}`;
  }
  if (pathname.startsWith('/research/')) {
    const researchId = pathname.split('/')[2];
    return `Research: ${researchId.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}`;
  }
  if (pathname.startsWith('/developers/')) {
    const section = pathname.split('/')[2];
    return `Developers: ${section.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}`;
  }
  
  return 'Liquicent';
};

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }
    
    const title = getPageTitle(location.pathname);
    trackPageView(location.pathname, title);
  }, [location.pathname]);

  return null;
};

export default PageTracker;
